export const DEV_PANEL_BANNER_TEST_ID = 'dev-panel-mock-banner';
